import { APP_ENVIRONMENT, AUTH_HOST_URL, IMAGE_HOST_URL } from "../Constants/Constants";
import { getStorageItem, setStorageItem } from "./storageFunction";

const getApiCallLocalPath = (type = "auth") => {
  if (type === "public") {
    let hostName = getStorageItem("Zino_public_domain_web");
    if (!hostName) {
      setStorageItem("Zino_public_domain_web", `${window.location.origin}/`);
      hostName = `${window.location.origin}/`;
    }
    return hostName;
  } else {
    let hostName = getStorageItem("Zino_domain_web");
    if (!hostName) {
      setStorageItem("Zino_domain_web", `${window.location.origin}/`);
      hostName = `${window.location.origin}/`;
    }
    return hostName;
  }
};

const getApiCallImagePath = () => {
  let environmentValue = APP_ENVIRONMENT || "local";
  if (environmentValue === "local") {
    let hostName = IMAGE_HOST_URL;
    return hostName;
  } else {
    let hostName = window.location.origin;
    return hostName;
  }
};

const getApiCallHostPath = () => {
  let environmentValue = APP_ENVIRONMENT || "local";
  if (environmentValue === "local") {
    let hostName = AUTH_HOST_URL;
    return hostName;
  } else {
    let hostName = window.location.origin;

    return hostName;
  }
};

const getZinoDomainAppData = () => {
  let domainData = getStorageItem("Zino_domain_app_data");
  return JSON.parse(domainData);
};

const toastErrorMessageStyle = () => {
  return {
    style: {
      border: "1px solid red",
      padding: "16px",
      color: "red"
    },
    iconTheme: {
      primary: "red",
      secondary: "#FFFAEE"
    }
  };
};

const toastSuccessMessageStyle = () => {
  return {
    style: {
      border: "1px solid green",
      padding: "16px",
      color: "green"
    },
    iconTheme: {
      primary: "green",
      secondary: "#FFFAEE"
    }
  };
};

const detectDeviceType = () => {
  const environment = APP_ENVIRONMENT || "local";
  const ua = navigator.userAgent;

  const isTablet = () => /iPad|Tablet|PlayBook|Silk|Kindle/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua));

  const isMobile = () => /iPhone|Android.*Mobile|Windows Phone|webOS|BlackBerry/i.test(ua);

  const getDeviceType = () => {
    if (isTablet()) return "Desktop"; // Treat tablets as Desktop
    if (isMobile()) return "Mobile";
    return "Desktop";
  };

  if (environment === "local") {
    return getDeviceType();
  } else {
    const origin = window.location.origin;
    if (/https?:\/\/m\./i.test(origin)) {
      return "Mobile"; // Force Mobile on m. subdomain
    }
    return getDeviceType();
  }
};

export {
  getApiCallLocalPath,
  toastErrorMessageStyle,
  toastSuccessMessageStyle,
  getZinoDomainAppData,
  getApiCallHostPath,
  detectDeviceType,
  getApiCallImagePath
};

window.getApiCallLocalPath = getApiCallLocalPath;
